import { render, staticRenderFns } from "./index3.8.vue?vue&type=template&id=cb1a9962&scoped=true"
import script from "./index3.8.vue?vue&type=script&lang=js"
export * from "./index3.8.vue?vue&type=script&lang=js"
import style0 from "./index3.8.vue?vue&type=style&index=0&id=cb1a9962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1a9962",
  null
  
)

export default component.exports